import z, { ZodType } from 'zod';
import { Player } from './player';
import { PlayerVoucherItem } from './player-voucher-item';

export type PatchedPlayer = Pick<Player, 'id'> &
	Partial<Omit<Player, 'id' | 'voucherItem'>> & {
		voucherItem?: Partial<PlayerVoucherItem> | null;
	};

export type PlayersPatchedResponse = {
	deviceId: number;
	players: PatchedPlayer[];
};

const patchedPlayerVoucherItemSchema = z.object({
	currentDeposit: z.number().optional(),
	totalDeposit: z.number().optional(),
	currentWagering: z.number().optional(),
	totalWagering: z.number().optional(),
});

export const patchedPlayerSchema = z.object({
	id: z.number(),
	name: z.string().optional(),
	balance: z.number().optional(),
	order: z.number().optional(),
	isConnected: z.boolean().optional(),
	voucherItem: patchedPlayerVoucherItemSchema.nullable().optional(),
}) as ZodType<PatchedPlayer>;

export const playersPatchedResponseSchema: ZodType<PlayersPatchedResponse> = z.object({
	deviceId: z.number(),
	players: z.array(patchedPlayerSchema),
});
